import tourConfig from '../common/tour/config';

const tourStepsSync = (language) => {
	let tourOptions = tourConfig.getOptions(language);
	tourOptions.steps = [
		{
			element: '.container-main-principal',
			intro: language.tour.summarySleepSyncTour.upperSector,
			position: 'bottom'
		},
		{
			element: '.top-filters-tour',
			intro: language.tour.summarySleepSyncTour.topFilters,
			position: 'right'
		},
		{
			element: '.help-buttons-tour',
			intro: language.tour.summarySleepSyncTour.helpButtons,
			position: 'right'
		},
		{
			element: '.indicator-tour',
			intro: language.tour.summarySleepSyncTour.incidentsRate,
			position: 'right'
		},
		{
			element: '.difference-indicators-tour',
			intro: language.tour.summarySleepSyncTour.lastPeriod,
			position: 'right'
		},
		{
			element: '.indicator-distribution-tour',
			intro: language.tour.summarySleepSyncTour.syncDistribution,
			position: 'right'
		},
		{
			element: '.evolution',
			intro: language.tour.summarySleepSyncTour.incidentsRateEvolution,
			position: 'left'
		},
		{
			element: '.module-table table',
			intro: language.tour.summarySleepSyncTour.summaryTable,
			position: 'top'
		},
		{
			element: '.table-filter',
			intro: language.tour.summarySleepSyncTour.tableFilter,
			position: 'right'
		},
		{
			element: '.module-table th:first-child+th',
			intro: language.tour.summarySleepSyncTour.personsColumn,
			position: 'right'
		},
		{
			element: '.module-table th:first-child+th+th',
			intro: language.tour.summarySleepSyncTour.incidentsColumn,
			position: 'right'
		},
		{
			element: '.module-table th:first-child+th+th+th',
			intro: language.tour.summarySleepSyncTour.percentageIncidentColumn,
			position: 'right'
		},
		{
			element: '.module-table th:first-child+th+th+th+th',
			intro: language.tour.summarySleepSyncTour.evolutionIncidentColumn,
			position: 'right'
		},
		{
			element: '.module-table th:first-child+th+th+th+th+th',
			intro: language.tour.summarySleepSyncTour.syncDistributionColumn,
			position: 'left'
		},
		{
			element: '.module-table th:first-child+th+th+th+th+th+th',
			intro: language.tour.summarySleepSyncTour.tasksDistributionColumn,
			position: 'left'
		},
		{
			element: '.excel-buttons',
			intro: language.tour.summarySleepSyncTour.excelButton,
			position: 'left'
		}
	];

	return tourOptions;
};

export default tourStepsSync;


// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_sleep/tourStepsSync.js